import { Upload } from "antd";
import styled from "styled-components";

const FileField = styled(Upload)`
  width: 100%;
`;

export { FileField };
